import React, { useMemo, useState } from "react";
import { Pressable, Text, View } from "react-native";
import AIExhibitNarrationPressable from "../audio/AIExhibitNarrationPressable";
import { useAIExhibitFixedNarration } from "../audio/useAIExhibitFixedNarration";
import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

const NARRATION_BY_DOMAIN_ID = Object.freeze({
  medicine: "humans_ai_medicine",
  education: "humans_ai_education",
  science: "humans_ai_science",
  creative: "humans_ai_creative",
});
import { getAIExhibitBatch4Copy } from "../content/aiExhibitBatch4Content";

export default function HumansPlusAIScreen({
  language="en",
  audioEnabled=false,
}) {
  const { playNarration } = useAIExhibitFixedNarration({
    audioEnabled,
    language,
  });
  const t=getAIExhibitBatch4Copy(language).humans;
  const [id,setId]=useState(t.domains[0].id);
  const d=useMemo(()=>t.domains.find(x=>x.id===id)||t.domains[0],[id,t.domains]);
  return <View style={{padding:28}}>
    <Text style={{color:C.accent,fontSize:13,fontWeight:"900",letterSpacing:1.2}}>{t.eyebrow}</Text>
    <Text style={{color:C.text,fontSize:44,lineHeight:50,fontWeight:"900",marginTop:8}}>{t.title}</Text>
    <Text style={{color:C.muted,fontSize:18,lineHeight:27,marginTop:8,maxWidth:970}}>{t.subtitle}</Text>
    <Text style={{color:C.text,fontSize:19,fontWeight:"900",marginTop:24}}>{t.choose}</Text>
    <View style={{flexDirection:"row",flexWrap:"wrap",gap:10,marginTop:12}}>{t.domains.map(x=>{const active=x.id===id;return <Pressable key={x.id} onPress={()=>{
      setId(x.id);
      playNarration(NARRATION_BY_DOMAIN_ID[x.id]);
    }} style={({pressed})=>({flex:1,minWidth:180,minHeight:82,padding:14,borderRadius:15,borderWidth:active?2:1,borderColor:active?C.accent:C.border,backgroundColor:active||pressed?C.accentSoft:C.surfaceRaised,flexDirection:"row",alignItems:"center",gap:10})}><Text style={{fontSize:27}}>{x.icon}</Text><Text style={{color:C.text,fontSize:17,fontWeight:"900"}}>{x.title}</Text></Pressable>})}</View>
    <View style={{flexDirection:"row",flexWrap:"wrap",gap:16,marginTop:18}}>
      <View style={{flex:1,minWidth:340,padding:22,borderRadius:18,borderWidth:1,borderColor:C.accent,backgroundColor:C.accentSoft}}><Text style={{color:C.accent,fontSize:13,fontWeight:"900"}}>{t.aiHelps.toUpperCase()}</Text><Text style={{color:C.text,fontSize:18,lineHeight:29,marginTop:10}}>{d.ai}</Text></View>
      <View style={{flex:1,minWidth:340,padding:22,borderRadius:18,borderWidth:1,borderColor:C.success,backgroundColor:C.surfaceRaised}}><Text style={{color:C.success,fontSize:13,fontWeight:"900"}}>{t.humansMatter.toUpperCase()}</Text><Text style={{color:C.text,fontSize:18,lineHeight:29,marginTop:10}}>{d.human}</Text></View>
    </View>
    <AIExhibitNarrationPressable
      audioEnabled={audioEnabled}
      onPress={() => playNarration("humans_ai_key_takeaway")}
      style={{marginTop:18,padding:19,borderRadius:16,borderLeftWidth:5,borderWidth:1,borderColor:C.border,borderLeftColor:C.accent,backgroundColor:C.surfaceRaised}}
    ><Text style={{color:C.text,fontSize:20,lineHeight:29,fontWeight:"900"}}>{t.key}</Text></AIExhibitNarrationPressable>
    <View style={{marginTop:14,padding:15,borderRadius:14,borderWidth:1,borderColor:C.warning,backgroundColor:C.accentSoft}}><Text style={{color:C.text,fontSize:15,lineHeight:23}}>{t.caution}</Text></View>
  </View>;
}
